import { TokenFormatEnum } from 'v3/shared/constants/token-type.enum';
import { ITokenState } from './types';

export const tokenInitialState: ITokenState = {
  code: '',
  selectedOption: TokenFormatEnum.SMS,
  count: 0,
  canSendToken: false,
  flagSelectForPreContract: false,
};
